import { useGetCashBalancesAvailable } from './useGetCashBalancesAvailable'
import { AxiosError } from 'axios'

type AmountAvailableData = {
  amountAvailable?: number
  isLoading: boolean
  error: AxiosError | null
}

export const useGetAmountAvailable = (accountNumber: string): AmountAvailableData => {
  const { data, isLoading, error } = useGetCashBalancesAvailable(accountNumber)

  return { amountAvailable: data?.balanceDetails.amountAvailableToWithdraw, isLoading, error }
}
